import React from "react";

export default function SQLServer_CURRENT_USER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CURRENT_USER</h1>
      <p>This is the SQLServer_CURRENT_USER component generated from the SQL JSON.</p>
    </div>
  );
}
